import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {AppSettings} from '../../proyect.conf';
import {map} from 'rxjs/operators';
import {TiposOcupacionesCapacidadPagos} from '../_models/tipos-ocupaciones-configuraciones-capacidad-pagos';
import {TiposOcupacionesConfiguracionesDescuentosSalarios} from '../_models/tiposOcupacionesConfiguracionesDescuentosSalarios';

@Injectable({
  providedIn: 'root'
})
export class TiposOcupacionesConfiguracionesCapacidadPagosService {
  private rutService = AppSettings.rutServiciosRG + '/api/tiposOcupacionesConfiguracionesCapacidadPagos/';
  private rutDescuentoSalario = AppSettings.rutServiciosRG + '/api/tiposOcupacionesConfiguracionesDescuentosSalarios/';

  constructor(
    private httClient: HttpClient,
    private autServicio: AutenticacionService) { }

  obternerOcupacionCofiguracionCapacidadPago(idTipoOcupacionConfiguracion : string){
    return this.httClient.get(`${this.rutService}idTipoOcupacionConfiguracion/${idTipoOcupacionConfiguracion}`).pipe(map(res => res as TiposOcupacionesCapacidadPagos[]));
  }
  guardarOcupacionCofiguracionCapacidadPago(data : TiposOcupacionesCapacidadPagos){
    return this.httClient.post(`${this.rutService}bulk`,[data]).pipe(map(res => res as any));
  }

  tiposOcupacionesConfiguracionesDescuentosSalariosAll(idTipoOcupacionConfiguracion : string){
    return this.httClient.get(`${this.rutDescuentoSalario}idTipoOcupacionConfiguracion/${idTipoOcupacionConfiguracion}`).pipe(map(res => res as TiposOcupacionesConfiguracionesDescuentosSalarios[]));
  }
  tiposOcupacionesConfiguracionesDescuentosSalariosEnable(idTipoOcupacionConfiguracion : string){
    return this.httClient.get(`${this.rutDescuentoSalario}idTipoOcupacionConfiguracion/${idTipoOcupacionConfiguracion}/enabled`).pipe(map(res => res as TiposOcupacionesConfiguracionesDescuentosSalarios[]));
  }
  guardarTiposOcupacionesConfiguracionesDescuentosSalarios(data :TiposOcupacionesConfiguracionesDescuentosSalarios[] ){
    return this.httClient.post(`${this.rutDescuentoSalario}bulk `,data).pipe(map(res => res as any));
  }
}
